// extracted by mini-css-extract-plugin
export var primitiveLabel = "_vp-0";